import { useContext, useEffect, useState } from 'react';
import { Context as TravelAgencyContext } from '../../api/travelAgencyAccounts/context';
import { voucherSourceTargetTypesEnum } from '../../api/travelFiles/helpers';

interface IAgentInfoDetails {
    name: string;
    address: string;
    city: string;
    phones: any[];
    vatNumber: string;
    _id: string;
}

const useGetAgentInfoDetails = (documentGenerationData: any) => {
    const travelAgencyContext = useContext(TravelAgencyContext);
    const [agentInfoDetails, setAgentInfoDetails] = useState<IAgentInfoDetails>({
        name: '',
        address: '',
        vatNumber: '',
        _id: '',
        city: '',
        phones: []
    });

    useEffect(() => {
        if (
            documentGenerationData?.sourceType === 'agent' &&
            documentGenerationData.sourceId
        ) {
            getTravelAgentDetails(documentGenerationData.sourceId);
        }
    }, [documentGenerationData]);

    const getTravelAgentDetails = async (id: string) => {
        try {
            if (!travelAgencyContext?.getById) return;
            const fetchedTravelAgentDetails = await travelAgencyContext.getById(id);
   
            const {
                companyName,
                address: { city, address },
                //@ts-ignore
                phones,
                vatNumber,
                _id
            } = fetchedTravelAgentDetails;
            setAgentInfoDetails({
                name: companyName,
                address: `${city} ${address}`,
                vatNumber: vatNumber?.toString() ?? '',
                _id,
                city: city ?? '',
                phones: [...phones]
            });
        } catch (err) {
            console.error(err);
        }
    };
    return agentInfoDetails;
};

export default useGetAgentInfoDetails;
